// storybook-check-ignore
export const FooterRoutes = {
  CCPA: 'https://www.opendoor.com/privacy#ccpa',
  PRIVACY_POLICY: 'https://opendoor.com/privacy',
  PRIVACY_REQUEST: 'https://opendoor-privacy.relyance.ai/',
  TERMS_OF_SERVICE: 'https://opendoor.com/terms',
};

export const LandingPageRoutes = {
  AGENTS: 'https://opendoor.com/agents',
};
